import { createFileRoute } from "@tanstack/react-router";
import DebugLogs from "@/pages/DebugLogs";

export const Route = createFileRoute("/debug/logs")({ component: DebugLogs });
